/**
 * @generated SignedSource<<b0e2cdb69406d0e119e58195c907b890>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AuthenticationAnonymousUserForm_authenticationConfig",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "forceEmailForAnonymousUsers",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enableEmailConsent",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailConsentLabel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FormResponse",
      "kind": "LinkedField",
      "name": "anonymousUserSubscriptionFormResponse",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "answers",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "Answers_answers"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AuthenticationConfig",
  "abstractKey": null
};

node.hash = "c51c5afdcffd1e5fb690baf62f3276e7";

module.exports = node;
